import gql from 'graphql-tag';
import { PAGINATION_VIEW_MODEL_FRAGMENT } from 'shared';

import { DEAL_LISTING_ACTIVITY_FRAGMENT } from '../../fragments/dealListingEventActivity.fragment';

export const CALENDAR_EVENTS_LISTING = gql`
  query CalendarEventsListing($input: CalendarEventsListingInput!) {
    dealActivity {
      result: calendarEventsListing(input: $input) {
        error
        success
        items {
          ...DealListingEventActivityFields
        }
        pagination {
          ...PaginationMetaViewModel
        }
      }
    }
  }
  ${DEAL_LISTING_ACTIVITY_FRAGMENT}
  ${PAGINATION_VIEW_MODEL_FRAGMENT}
`;
